module.exports = __webpack_public_path__ + "img/load-more.021d358a.svg";